/* eslint-disable @typescript-eslint/no-explicit-any */
import {Injectable} from '@angular/core';
import {PointConstructionToolService} from './services/point-construction-tool.service';
import {TotalBoundaryDistanceConstructionToolService} from './services/total-boundary-distance-construction-tool.service';
import {PolygonConstructionToolService} from './services/polygon-construction-tool.service';
import {PolylineConstructionToolService} from './services/polyline-construction-tool.service';
import {MergePointsConstructionToolService} from './services/merge-points-construction-tool.service';
import {MergeLinesConstructionToolService} from './services/merge-lines-construction-tool.service';
import {LotConstructionToolService} from './services/lot-construction-tool.service';
import {LineConstructionToolService} from './services/line-construction-tool.service';
import {DissectLineConstructionToolService} from './services/dissect-line-construction-tool.service';
import {CornerOffsetConstructionToolService} from './services/corner-offset-construction-tool.service';
import {ControlPointConstructionToolService} from './services/control-point-construction-tool.service';
import {BoundaryOffsetConstructionToolService} from './services/boundary-offset-construction-tool.service';
import {AngleConstructionToolService} from './services/angle-construction-tool.service';
import {ToolServiceInterface} from './services/tool-service-interface';
import {Observable} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ConstructionToolServiceFactory {
    title = 'ConstructionToolServiceFactory';

    constructor(
        private angleConstructionToolService: AngleConstructionToolService,
        private boundaryOffsetConstructionToolService: BoundaryOffsetConstructionToolService,
        private controlPointConstructionToolService: ControlPointConstructionToolService,
        private cornerOffsetConstructionToolService: CornerOffsetConstructionToolService,
        private dissectLineConstructionToolService: DissectLineConstructionToolService,
        private pointConstructionToolService: PointConstructionToolService,
        private lineConstructionToolService: LineConstructionToolService,
        private lotConstructionToolService: LotConstructionToolService,
        private mergeLinesConstructionToolService: MergeLinesConstructionToolService,
        private mergePointsConstructionToolService: MergePointsConstructionToolService,
        private polylineConstructionToolService: PolylineConstructionToolService,
        private polygonConstructionToolService: PolygonConstructionToolService,
        private totalBoundaryDistanceConstructionToolService: TotalBoundaryDistanceConstructionToolService
    ) {}

    getConstructionToolService(type: string): ToolServiceInterface {
        console.debug(`${this.title} - getConstructionToolService - type: ${type}`);

        let service: ToolServiceInterface;

        switch (type) {
            case 'point':
                service = this.pointConstructionToolService;
                break;
            case 'line':
                service = this.lineConstructionToolService;
                break;
            case 'polyline':
                service = this.polylineConstructionToolService;
                break;
            case 'polygon':
                service = this.polygonConstructionToolService;
                break;
            case 'angle':
                service = this.angleConstructionToolService;
                break;
            case 'controlPoint':
                service = this.controlPointConstructionToolService;
                break;
            case 'lot':
                service = this.lotConstructionToolService;
                break;
            case 'boundaryOffset':
                service = this.boundaryOffsetConstructionToolService;
                break;
            case 'cornerOffset':
                service = this.cornerOffsetConstructionToolService;
                break;
            case 'totalBoundaryDistance':
                service = this.totalBoundaryDistanceConstructionToolService;
                break;
            case 'dissectLine':
                service = this.dissectLineConstructionToolService;
                break;
            case 'mergePoints':
                service = this.mergePointsConstructionToolService;
                break;
            case 'mergeLines':
                service = this.mergeLinesConstructionToolService;
                break;
            default:
                service = {
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    create(atttibutes: any): Observable<any> {
                        return undefined;
                    }
                };
                break;
        }

        return service;
    }
}
